/**
 * The backend's formation journey (`hyke/onboarding/questionnaire/steps/formation.py`): which step
 * follows which, given the answers so far. Kept free of app imports so it can be tested on its own.
 */

export type StepAnswers = Record<string, unknown>;

export const END_STEP = 'sign_ein';

/** The next step after `step`, given the answers so far; `null` for an end or terminal step. */
export function nextStep(step: string, steps: Record<string, StepAnswers>): string | null {
    switch (step) {
        case 'intro':
            return 'personal_info';
        case 'personal_info':
            return steps.personal_info?.ssn_provided === false ? 'no_fit_ssn' : 'personal_address_info';
        case 'personal_address_info':
            return steps.personal_info?.legally_married ? 'spousal_info' : 'business_name';
        case 'spousal_info':
            return 'business_name';
        case 'business_name':
            return steps.business_name?.maxRetriesReached ? 'max_retries_reached' : 'business_address_info';
        case 'business_address_info':
            return 'ein_info';
        case 'ein_info':
            return 'review';
        case 'review':
            return END_STEP;
        default:
            return null;
    }
}

/** The route from `start` onward, following the answers given so far. */
export function walkFrom(start: string, steps: Record<string, StepAnswers>): string[] {
    const route: string[] = [];
    let step: string | null = start;
    while (step !== null && !route.includes(step)) {
        route.push(step);
        step = nextStep(step, steps);
    }
    return route;
}
